(function () {
  'use strict';

  angular
    .module('events.edit')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('settings.events.edit', {
        url: '/:eventId/edit',
        templateUrl: 'settings/events/edit/edit.tpl.html',
        controller: 'EventsEditCtrl',
        controllerAs: 'vm'
      })
      .state('settings.events.add', {
        url: '/add',
        templateUrl: 'settings/events/edit/edit.tpl.html',
        controller: 'EventsEditCtrl',
        controllerAs: 'vm'
      })
    ;
  }
}());
